import { TranslateService } from '@ngx-translate/core';
import { ParamApplication } from './../../models/ParamApp';

import { BehaviorSubject, Observable, throwError,Subject, forkJoin, of, from } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Injectable, Output, ChangeDetectorRef } from '@angular/core';
import { User } from '../../models/user.model'
import { MedicalInfo } from '../../models/MedicalInformation';
import { Router } from '@angular/router';


@Injectable()

export class AuthService {
  private router: Router;
  private _listnersMedical$ = new Subject<any>();
  private currentUserSubject: BehaviorSubject<User>;
  public currentUser: Observable<User>;
  public paramApp: Observable<ParamApplication>;
  public paramAppSubject: BehaviorSubject<ParamApplication>;
  public medicalUserSubject: BehaviorSubject<MedicalInfo>;
  public medicalUser: Observable<MedicalInfo>;
  private currentLanguagesSubject: BehaviorSubject<any>;
  public currentLanguages: Observable<any>;
  private headers = new HttpHeaders({"Content-Type": "application/json","Access-Control-Allow-Origin":"*"});
  private options = { headers: this.headers };
  constructor(private http: HttpClient, private translateService: TranslateService) {

    this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
    this.currentUser = this.currentUserSubject.asObservable();
    this.medicalUserSubject = new BehaviorSubject<MedicalInfo>(JSON.parse(localStorage.getItem('currentMedicalUser')));
    this.medicalUser = this.medicalUserSubject.asObservable();
    this.currentLanguagesSubject = new BehaviorSubject<any>(JSON.parse(localStorage.getItem('currentLanguage')));
    this.currentLanguages = this.currentLanguagesSubject.asObservable();
  }

  public get currentUserValue(): User {
    return this.currentUserSubject.value;
  }
  public get medicalUserValue(): MedicalInfo {

    return this.medicalUserSubject.value;

  }

  public get paramAppValue(): ParamApplication {
    return this.paramAppSubject.value;
  }

  public get currentLanguagesValue(): any {
    return this.currentLanguagesSubject.value;
  }

  listenMedicalInfo(): Observable<any> {
    return this._listnersMedical$.asObservable();
  }

  pushMedicalInfo(filterBy: any) {
    this._listnersMedical$.next(filterBy);
  }

  // login(SerialNumberInput: string, idDevice: string, userId?: string) {
  //   let idUser='';
  //   if (userId !== null)
  //   idUser = '&id_user='+userId
  // console.log("idUser",idUser);

  //   return this.http.get<any>(`${environment.apiUrl}/finder_scan_tag?sn=` + SerialNumberInput.replace('#','')+'&id_device='+idDevice+ idUser)
  //     .pipe(map(user => {
  //       if (user && !user?.error) {
  //         console.log("suer", user);
  //         localStorage.setItem('currentUser', JSON.stringify(user));
  //         console.log("currentUser", user);
  //         this.currentUserSubject.next(user);
  //       }
  //       return user;
  //     }));
  // }

//   login(SerialNumberInput: string, idDevice: string, userId?: string) {
//     let idUser = '';
//     if (userId !== null) idUser = '&id_user=' + userId;

//     return this.http.get<any>(`${environment.apiUrl}/finder_scan_tag?sn=${SerialNumberInput.replace('#', '')}&id_device=${idDevice}${idUser}`)
//         .pipe(
//             switchMap(user => {
//               if (user && !user?.error) {
//                 console.log("suer", user);
            
//                 // Handle translation if tag_custum_message exists
//                 if (user.tag_info?.tag_info?.tag_custum_message) {
//                     return this.handleTranslation(user).pipe(
//                         tap(() => this.saveUser(user)) // Save after translation
//                     );
//                 } else {
//                     this.saveUser(user);
//                     return of(user); // Wrap user in an observable
//                 }
//             }
//               return of(user); // Return user even if there's an error property
//             })
//         );
// }




// Mock APi Response 


// login(SerialNumberInput: string, idDevice: string, userId?: string) {
//   const mockApiResponse = {
//     "chat_members": [
//         "foundy@gmail.com"
//     ],
//     "chatbot_assitant": [
//         {
//             "api_key": "https://api.eu-gb.assistant.watson.cloud.ibm.com/instances/94ada572-b348-444b-bcef-68acb122b5de/v2/assistants/c45d5b3e-a9ee-4f1f-ba28-4c2e77cde926/sessions",
//             "id": "c45d5b3e-a9ee-4f1f-ba28-4c2e77cde926",
//             "job": "medical",
//             "url": "https://api.eu-gb.assistant.watson.cloud.ibm.com/instances/81dfcc67-f35c-4ca4-9cfa-377e7e1fadbc/v2/assistants/e12020d0-7b9f-4fab-b29e-6588cc76a508/sessions"
//         },
//         {
//             "api_key": "https://api.eu-gb.assistant.watson.cloud.ibm.com/instances/94ada572-b348-444b-bcef-68acb122b5de/v2/assistants/5c8d2b11-4f35-4ac8-b392-2ae4024d08cc/sessions",
//             "id": "5c8d2b11-4f35t-4ac8-b392-2ae4024d08cc",
//             "job": "object",
//             "url": "https://api.eu-gb.assistant.watson.cloud.ibm.com/instances/81dfcc67-f35c-4ca4-9cfa-377e7e1fadbc/v2/assistants/e12020d0-7b9f-4fab-b29e-6588cc76a508/sessions"
//         }
//     ],
//     "finder_info": {
//         "emergency_service": "911",
//         "id": "289dd10bbb01640edf7d654f414f8624"
//     },
//     "tag_info": {
//         "currency": {
//             "active": 1,
//             "allow_custum_field": 1,
//             "allow_value": 1,
//             "custum_field": "invitation for a cofee",
//             "id": 1,
//             "id_currency_label": 1,
//             "value": 10
//         },
//         "emergency_contact_user": [],
//         "features": {
//             "medical_add_email": 1,
//             "medical_add_email2": 1,
//             "medical_add_phone": 1,
//             "medical_add_profile_pic": 1,
//             "medical_ai_chat": 1,
//             "medical_also_contact_limit": 5,
//             "medical_attachement": 1,
//             "medical_audio_call": 1,
//             "medical_block_card": 1,
//             "medical_chat": 1,
//             "medical_custom_thankyou": 1,
//             "medical_default_thankyou": 1,
//             "medical_gift": 1,
//             "medical_link_profile": 1,
//             "medical_lock_screen": 1,
//             "medical_mail_contact": 1,
//             "medical_medical_contact_limit": 5,
//             "medical_onboarding": 1,
//             "medical_poster": 1,
//             "medical_push_notification": 1,
//             "medical_release_info": 1,
//             "medical_reminders": 1,
//             "medical_share_gps": 1,
//             "medical_share_mail": 1,
//             "medical_share_name": 1,
//             "medical_share_phone": 1,
//             "medical_share_picture": 1,
//             "medical_sms_contact": 1,
//             "medical_video_call": 1,
//             "medical_view_export_records": 1,
//             "object_add_email2": 1,
//             "object_add_picture": 1,
//             "object_ai_chat": 1,
//             "object_also_contact_limit": 5,
//             "object_attachement": 1,
//             "object_audio_call": 1,
//             "object_chat": 1,
//             "object_custom_thankyou": 1,
//             "object_gift": 1,
//             "object_lockscreen": 1,
//             "object_mail_contact": 1,
//             "object_onboarding": 1,
//             "object_poster": 1,
//             "object_push_notification": 1,
//             "object_reminders": 1,
//             "object_share_gps": 1,
//             "object_share_mail": 1,
//             "object_share_name": 1,
//             "object_share_phone": 1,
//             "object_share_picture": 1,
//             "object_sms_contact": 1,
//             "object_video_call": 1,
//             "object_view_export_records": 1,
//             "pet_add_email": 1,
//             "pet_add_email2": 1,
//             "pet_add_phone": 1,
//             "pet_add_picture": 1,
//             "pet_ai_chat": 1,
//             "pet_also_contact_limit": 5,
//             "pet_attachement": 1,
//             "pet_audio_call": 1,
//             "pet_chat": 1,
//             "pet_custom_thankyou": 1,
//             "pet_default_thankyou": 1,
//             "pet_gift": 1,
//             "pet_mail_contact": 1,
//             "pet_onboarding": 1,
//             "pet_poster": 1,
//             "pet_push_notification": 1,
//             "pet_reminders": 1,
//             "pet_share_gps": 1,
//             "pet_share_mail": 1,
//             "pet_share_name": 1,
//             "pet_share_phone": 1,
//             "pet_share_picture": 1,
//             "pet_sms_contact": 1,
//             "pet_video_call": 1,
//             "pet_view_export_records": 1,
//             "show_ads_homepage": 1,
//             "show_ads_notifications": 1,
//             "tag_log_history": 1
//         },
//         "other_info": [],
//         "preference_user": {
//             "allow_live_chat": "1",
//             "allow_reward": "0",
//             "allow_share_emails": "1",
//             "allow_share_name": "1",
//             "allow_share_phone": "1",
//             "allow_share_picture": "1",
//             "include_child_name": "0",
//             "include_child_picture": "0",
//             "include_mail1": "1",
//             "include_mail2": "0",
//             "include_mobile": "1",
//             "reward_currency": "0",
//             "reward_sum": "0"
//         },
//         "tag_info": {
//             "active": 1,
//             "active_emergency": 1,
//             "archive": 0,
//             "emergency": 1,
//             "id_finder_website": 1,
//             "id_member": "b327c02ddad53e2fbb1c163884ae837f",
//             "id_picture": 1638,
//             "id_tag": 23022,
//             "id_tag_categorie": 2,
//             "id_type": 13,
//             "picture_name": "ae9f884e7c4bd4d785243dd2cf21891589afe537c507504c90e7f2aaba7f4282.png",
//             "picture_url": "https://static.found.me/ae9f884e7c4bd4d785243dd2cf21891589afe537c507504c90e7f2aaba7f4282.png",
//             "serial_number": "THJPWMWTW",
//             "tag_custum_message": "Thanks so much for finding my stuff",
//             "tag_description": null,
//             "tag_label": null,
//             "type_label": "Lock Screen QR Code"
//         }
//     },
//     "tag_member": {
//         "member_profile_picture_url": "https://static.found.me/f08ff774722012bcb314d67210b07abd0c57083b99b59886dd66f3cb021c1bd8.jpg",
//         "tag_member_allow_chat": 1,
//         "tag_member_first_name": "Homer Simpson",
//         "tag_member_mail1": "V60@foundme.com",
//         "tag_member_mails": "V60@foundme.com",
//         "tag_member_mobile": "+19048783425",
//         "tag_member_phones": ""
//     },
//     "tag_creator": {
//         "child_picture_url": null,
//         "current_member_id": "33169e6c57113f6de6b49fb5d8d32838",
//         "email": null,
//         "tag_creator_allow_chat": 1,
//         "tag_creator_first_name": "Homer Simpson",
//         "tag_creator_id": "33169e6c57113f6de6b49fb5d8d32838",
//         "tag_creator_mail1": "V60@foundme.com",
//         "tag_creator_mails": null,
//         "tag_creator_mobile": "+19048783425",
//         "tag_creator_phones": null,
//         "tag_creator_profile_picture_url": "https://static.found.me/f08ff774722012bcb314d67210b07abd0c57083b99b59886dd66f3cb021c1bd8.jpg",
//         "zulip_mail": "ed0e2a1fcd2a9748a6f1c901c18e05d6c3908b6584d5b44378eae9bf9aa872e5@user15390.com"
//     },
// };



//   return of(mockApiResponse).pipe(
//     switchMap(user => {
//       if (user && !user?.error) {
//         this.saveUser(user); // Save user directly
//       }
//       return of(user); // Return the observable either way
//     })
//   );
// }


// End Mock APi Response 





// Uncomment later 
login(SerialNumberInput: string, idDevice: string, userId?: string) {
    let idUser = '';
    if (userId !== null) idUser = '&id_user=' + userId;

    return this.http.get<any>(`${environment.apiUrl}/scan?sn=${SerialNumberInput.replace('#', '')}&id_device=${idDevice}${idUser}`)
        .pipe(
            switchMap(user => {
              if (user && !user?.error) {

              
                if (user.tag_member?.tag_creator_first_name) {
                  user.tag_member.tag_creator_first_name =
                    user.tag_member.tag_creator_first_name.replace('****', 'The Owner');
                }
              
                if (user.tag_member?.tag_member_first_name) {
                  user.tag_member.tag_member_first_name =
                    user.tag_member.tag_member_first_name.replace('****', 'The Owner');
                }
              
                // console.log("Fetched user ", user);
              
                // Call handleTranslation here to translate the custom message
                return this.handleTranslation(user);
              }
              
              return of(user);
               // Return user as-is if there was an error
            })
        );
}



handleTranslation(user: any) {
    return this.translationMessage(user.tag_info?.tag_info?.tag_custum_message).pipe(
        map((res: any) => {
            if (res?.translation?.translations?.[0]?.translation) {
                user.tag_info.tag_info.tag_custum_message = res.translation.translations[0].translation;
                // console.log("Translated user custom message:", res.translation.translations[0].translation);
            } else {
                // console.log("No translation found for user custom message:", user.tag_info.tag_info.tag_custum_message);
            }

            this.saveUser(user); // Save user after translation
            return user; // Return updated user
        }),
        catchError(error => {
            // console.log("Error translating user custom message:", error);
            this.saveUser(user); // Save user even if translation fails
            return of(user); // Return user in case of an error
        })
    );
}

saveUser(user: any) {
    localStorage.setItem('currentUser', JSON.stringify(user));
    // console.log("currentUser", user);
    this.currentUserSubject.next(user);
}





  sendsmsmail(sn:string, choice?: string){
    let isMedical = 0;
    if(localStorage.getItem('currentChatbot') === 'medical')
    isMedical = 1;
    else
    isMedical = 0;

    let choiceChat = "";
    if(choice) choiceChat = "&choice="+choice;

    return this.http.get<any>(`${environment.apiUrl}/send_sms_mail_to_allowed_emergency?is_medical=`+ isMedical+"&sn=" + sn+choiceChat)
    .pipe(map(data => {
      return data;
    }));
  }

  // Getemergency(SerialNumberInput: string, pincode:string) {
  //   return this.http.get<any>(`${environment.apiUrl}/get_medical_info_when_object_scaned?sn=`+SerialNumberInput +"&pincode="+pincode)
  //     .pipe(map(
  //       emergencydata => {
  //       localStorage.setItem('currentMedicalUser', JSON.stringify(emergencydata));
  //       this.medicalUserSubject.next(emergencydata);
  //       this.medicalUser = this.medicalUserSubject.asObservable();
  //       this.pushMedicalInfo( this.medicalUserSubject.value);
  //       return emergencydata;

  //     }),
  //     catchError(err => {
  //       const error = err.error.message || err.statusText;
  //       if(err.status === 500)
  //       {
  //          //window.alert(error)
  //       }

  //       return error;
  //     })
  //    );
  //   }





  // Getemergency(SerialNumberInput: string, pincode: string) {
  //   return this.http.get<any>(`${environment.apiUrl}/get_medical_info_when_object_scaned?sn=` + SerialNumberInput + "&pincode=" + pincode)
  //     .pipe(
  //       map(emergencydata => {
  //         console.log("entering emergencydata", emergencydata); // Log to check the structure of emergencydata
  
  //         // Check if medical_record and crtitcal_info are present
  //         if (emergencydata.medical_record && emergencydata.medical_record.crtitcal_info) {
  //           const translatePromises = emergencydata.medical_record.crtitcal_info.map((item: any) => {
  //             console.log("entering translatePromises for crtitcal_info item:", item); // Log the crtitcal_info item
  
  //             // Translate description and label fields if they exist
  //             const fieldsToTranslate = ['description', 'label'];
  
  //             return Promise.all(fieldsToTranslate.map(field => {
  //               if (typeof item[field] === 'string') {
  //                 console.log(`Translating ${field} for item:`, item[field]);
  //                 return this.translationMessage(item[field]).toPromise().then((res: any) => {
  //                   if (res?.translation?.translations?.length > 0 && res?.translation?.translations[0]?.translation) {
  //                     item[field] = res.translation.translations[0].translation;
  //                     console.log(`Translated ${field}:`, item[field]);
  //                   } else {
  //                     console.log(`No translation found for ${field} in item:`, item);
  //                   }
  //                 }).catch(error => {
  //                   console.log(`Error translating ${field}:`, error); // Log any translation errors
  //                 });
  //               }
  //               return Promise.resolve(); // Skip if the value is not a string
  //             }));
  //           });
  
  //           // Wait for all translations to finish
  //           return Promise.all(translatePromises).then(() => {
  //             // Translate custom message if it exists
  //             if (emergencydata?.user_general_info?.sub_users[0]?.user_general_info?.custum_message && typeof emergencydata?.user_general_info?.sub_users[0].user_general_info?.custum_message=== 'string') {
  //               return this.translationMessage(emergencydata.user_general_info.sub_users[0].user_general_info.custum_message).toPromise().then((res: any) => {
  //                 if (res?.translation?.translations?.length > 0 && res?.translation?.translations[0]?.translation) {
  //                   emergencydata.user_general_info.sub_users[0].user_general_info.custum_message = res.translation.translations[0].translation;
  //                   console.log("Translated custom message:", emergencydata.user_general_info.sub_users[0].user_general_info.custum_message);
  //                 } else {
  //                   console.log("No translation found for custom message:", emergencydata.user_general_info.sub_users[0].user_general_info.custum_message);
  //                 }
  //               }).catch(error => {
  //                 console.log("Error translating custom message:", error);
  //               });
  //             }
  //             return Promise.resolve(); // Skip if there's no custom message or it's not a string
  //           }).then(() => {
  //             // Store the translated emergency data in local storage and update the subject
  //             localStorage.setItem('currentMedicalUser', JSON.stringify(emergencydata));
  //             this.medicalUserSubject.next(emergencydata);
  //             this.medicalUser = this.medicalUserSubject.asObservable();
  //             this.pushMedicalInfo(this.medicalUserSubject.value);
  //             return emergencydata; // Return the translated data
  //           });
  //         } else {
  //           console.log("No crtitcal_info data found to translate.");
  //           return emergencydata; // If crtitcal_info is not present, return as is
  //         }
  //       }),
  //       catchError(err => {
  //         const error = err.error.message || err.statusText;
  //         if (err.status === 500) {
  //           // window.alert(error)
  //         }
  //         return error;
  //       })
  //     );
  // }
  


  // Getemergency(SerialNumberInput: string, pincode: string) {
  //   return this.http.get<any>(`${environment.apiUrl}/get_medical_info_when_object_scaned?sn=${SerialNumberInput}&pincode=${pincode}`)
  //     .pipe(
  //       switchMap(emergencydata => {
  //         console.log("entering emergencydata", emergencydata);
  
  //         if (emergencydata.medical_record && emergencydata.medical_record.crtitcal_info) {
  //           const translatePromises = emergencydata.medical_record.crtitcal_info.map((item: any) => {
  //             const fieldsToTranslate = ['description', 'label'];
  //             return Promise.all(fieldsToTranslate.map(field => {
  //               if (typeof item[field] === 'string') {
  //                 return this.translationMessage(item[field]).toPromise()
  //                   .then((res: any) => {
  //                     if (res?.translation?.translations?.[0]?.translation) {
  //                       item[field] = res.translation.translations[0].translation;
  //                       console.log("translated text : " , item[field]);
  //                     }
  //                   })
  //                   .catch(error => console.log(`Error translating ${field}:`, error));
  //               }
  //               return Promise.resolve();
  //             }));
  //           });
  
  //           return from(Promise.all(translatePromises)).pipe(
  //             switchMap(() => {
  //               if (emergencydata?.user_general_info?.sub_users[0]?.user_general_info?.custum_message) {
  //                 return from(this.translationMessage(emergencydata.user_general_info.sub_users[0].user_general_info.custum_message).toPromise())
  //                   .pipe(
  //                     map((res: any) => {
  //                       if (res?.translation?.translations?.[0]?.translation) {
  //                         emergencydata.user_general_info.sub_users[0].user_general_info.custum_message = res.translation.translations[0].translation;
  //                       }
  //                       return emergencydata;
  //                     })
  //                   );
  //               }
  //               return of(emergencydata);
  //             })
  //           );
  //         } else {
  //           return of(emergencydata);
  //         }
  //       }),
  //       tap(emergencydata => {
  //         localStorage.setItem('currentMedicalUser', JSON.stringify(emergencydata));
  //         this.medicalUserSubject.next(emergencydata);
  //         this.medicalUser = this.medicalUserSubject.asObservable();
  //         this.pushMedicalInfo(this.medicalUserSubject.value);
  //       }),
  //       catchError(err => {
  //         const error = err.error.message || err.statusText;
  //         return throwError(() => new Error(error));
  //       })
  //     );
  // }



// Getemergency(SerialNumberInput: string, pincode: string) {
//   return this.http.get<any>(`${environment.apiUrl}/get_medical_info_when_object_scaned?sn=${SerialNumberInput}&pincode=${pincode}`)
//     .pipe(
//       switchMap(emergencydata => {
//         const record = emergencydata?.medical_record;
//         if (!record) return of(emergencydata);

//         // --- Step 1: Critical fields (immediate translation) ---
//         const criticalFields: any[] = [];
//         const timedTranslation = (key: string, fn: Promise<any>, assignFn?: (result: any) => void) => {
//           const start = performance.now();
//           return from(fn).pipe(
//             map(result => {
//               console.log(`${key} translation took`, (performance.now() - start).toFixed(2), 'ms');
//               if (assignFn) assignFn(result);
//               return { key };
//             })
//           );
//         };

//         if (record.crtitcal_info) criticalFields.push(timedTranslation('crtitcal_info', this.translateCriticalInfo(record.crtitcal_info)));
//         if (record.medical_diseaces) criticalFields.push(timedTranslation('medical_diseaces', this.translateMedicalDiseases(record.medical_diseaces)));
//         if (record.immunization) criticalFields.push(timedTranslation('immunization', this.translateImmunizations(record.immunization)));

//         return forkJoin(criticalFields.length ? criticalFields : [of(null)]).pipe(
//           map(() => emergencydata)
//         );
//       }),
//       tap(emergencydata => {
//         // Step 2: Update UI immediately with critical info
//         localStorage.setItem('currentMedicalUser', JSON.stringify(emergencydata));
//         this.medicalUserSubject.next(emergencydata);
//         this.medicalUser = this.medicalUserSubject.asObservable();
//         this.pushMedicalInfo(this.medicalUserSubject.value);

//         // --- Step 3: Background translation for less critical fields ---
//         const record = emergencydata?.medical_record;
//         if (!record) return;

//         const backgroundFields = [
//           { key: 'other_medical_record_info', fn: record.other_medical_record_info, method: this.translateOtherDisorders.bind(this) },
//           { key: 'blood_info.diabates', fn: record.blood_info?.diabates, method: this.translateBloodDisorders.bind(this) },
//           { key: 'miscilanious', fn: record.miscilanious, method: this.translateMiscellaneous.bind(this) },
//           { key: 'insurance_info', fn: record.insurance_info, method: this.translateInsuranceInformation.bind(this) },
//           { key: 'resuscitate', fn: record.resuscitate, method: this.translateDNR.bind(this) },
//           { key: 'organ_donar', fn: record.organ_donar, method: this.translateOrganDonor.bind(this) },
//           { key: 'spoken_languages', fn: record.spoken_languages, method: this.translateSingleObject.bind(this) },
//           { key: 'distitnct_sign', fn: record.distitnct_sign, method: this.translateSingleObject.bind(this) },
//           { key: 'pet_at_home', fn: record.pet_at_home, method: this.translateSingleObject.bind(this) },
//           { key: 'eye_color', fn: record.eye_color, method: this.translateSingleObject.bind(this) },
//           { key: 'gender', fn: record.gender, method: this.translateSingleObject.bind(this) },
//           { key: 'religion_label', fn: record.religion_label, method: this.translateSingleObject.bind(this) }
//         ];

//         backgroundFields.forEach(field => {
//           if (field.fn) {
//             const start = performance.now();
//             field.method(field.fn).then(result => {
//               // Assign translated value if necessary
//               if (field.key.includes('.')) {
//                 const keys = field.key.split('.');
//                 record[keys[0]][keys[1]] = result;
//               } else {
//                 record[field.key] = result;
//               }
//               console.log(`${field.key} translation took`, (performance.now() - start).toFixed(2), 'ms (background)');

//               // Update storage/subject so UI sees the new data
//               localStorage.setItem('currentMedicalUser', JSON.stringify(emergencydata));
//               this.medicalUserSubject.next(emergencydata);
//               this.pushMedicalInfo(this.medicalUserSubject.value);
//             }).catch(err => {
//               console.warn(`Error translating ${field.key}:`, err);
//             });
//           }
//         });
//       }),
//       catchError(err => {
//         const error = err.error?.message || err.statusText;
//         return throwError(() => new Error(error));
//       })
//     );
// }







// Start of Medical Transaltion Section
  Getemergency(SerialNumberInput: string, pincode: string) {
    return this.http.get<any>(`${environment.apiUrl}/get_medical_info_when_object_scaned?sn=${SerialNumberInput}&pincode=${pincode}`)
      .pipe(
        switchMap(emergencydata => {
  
          // Translate critical info
          if (emergencydata.medical_record?.crtitcal_info) {
            return from(this.translateCriticalInfo(emergencydata.medical_record.crtitcal_info)).pipe(
              map(() => emergencydata) // Return translated data
            );
          }
          return of(emergencydata); 
        }),
  
        switchMap(emergencydata => {
          if (emergencydata?.medical_record?.medical_diseaces) {
            return from(this.translateMedicalDiseases(emergencydata.medical_record.medical_diseaces)).pipe(
              map(() => emergencydata) 
            );
          }
          return of(emergencydata); 
        }),
  
        switchMap(emergencydata => {
          if (emergencydata?.medical_record?.immunization) {
            return from(this.translateImmunizations(emergencydata.medical_record.immunization)).pipe(
              map(() => emergencydata) 
            );
          }
          return of(emergencydata); 
        }),
        
        switchMap(emergencydata => {
          if (emergencydata?.medical_record?.other_medical_record_info) {
            return from(this.translateOtherDisorders(emergencydata?.medical_record?.other_medical_record_info)).pipe(
              map(() => emergencydata) // Return translated data
            );
          }
          return of(emergencydata); 
        }), 
        
        switchMap(emergencydata => {
          if (emergencydata?.medical_record?.blood_info?.diabates) {
            return from(this.translateBloodDisorders(emergencydata?.medical_record?.blood_info?.diabates)).pipe(
              map(() => emergencydata) // Return translated data
            );
          }
          return of(emergencydata); 
        }),  
        
        switchMap(emergencydata => {
          if (emergencydata?.medical_record?.miscilanious) {
            return from(this.translateMiscellaneous(emergencydata?.medical_record?.miscilanious)).pipe(
              map(() => emergencydata) // Return translated data
            );
          }
          return of(emergencydata); 
        }), 
        
        switchMap(emergencydata => {
          if (emergencydata?.medical_record?.insurance_info) {
            return from(this.translateInsuranceInformation(emergencydata?.medical_record?.insurance_info)).pipe(
              map(() => emergencydata) // Return translated data
            );
          }
          return of(emergencydata); 
        }),  
        
        
        switchMap(emergencydata => {
          if (emergencydata?.medical_record?.resuscitate) {
            return from(this.translateDNR(emergencydata?.medical_record?.resuscitate)).pipe(
              map(() => emergencydata) // Return translated data
            );
          }
          return of(emergencydata); 
        }), 
        
        switchMap(emergencydata => {
          if (emergencydata?.medical_record?.organ_donar) {
            return from(this.translateOrganDonor(emergencydata?.medical_record?.organ_donar)).pipe(
              map(() => emergencydata) // Return translated data
            );
          }
          return of(emergencydata); 
        }),
        
        switchMap(emergencydata => {
  const spokenLang = emergencydata?.medical_record?.spoken_languages;
  if (spokenLang) {
    return from(this.translateSingleObject(spokenLang)).pipe(
      map(translated => {
        emergencydata.medical_record.spoken_languages = translated;
        return emergencydata;
      })
    );
  }
  return of(emergencydata);
}),

switchMap(emergencydata => {
  const distinct_sign = emergencydata?.medical_record?.distitnct_sign;
  if (distinct_sign) {
    return from(this.translateSingleObject(distinct_sign)).pipe(
      map(translated => {
        emergencydata.medical_record.distitnct_sign = translated;
        return emergencydata;
      })
    );
  }
  return of(emergencydata);
}),


switchMap(emergencydata => {
  const pet_at_home = emergencydata?.medical_record?.pet_at_home;
  if (pet_at_home) {
    return from(this.translateSingleObject(pet_at_home)).pipe(
      map(translated => {
        emergencydata.medical_record.pet_at_home = translated;
        return emergencydata;
      })
    );
  }
  return of(emergencydata);
}),


switchMap(emergencydata => {
  const eye_color = emergencydata?.medical_record?.eye_color;
  if (eye_color) {
    return from(this.translateSingleObject(eye_color)).pipe(
      map(translated => {
        emergencydata.medical_record.eye_color = translated;
        return emergencydata;
      })
    );
  }
  return of(emergencydata);
}),

switchMap(emergencydata => {
  const gender = emergencydata?.medical_record?.gender;
  if (gender) {
    return from(this.translateSingleObject(gender)).pipe(
      map(translated => {
        emergencydata.medical_record.gender = translated;
        return emergencydata;
      })
    );
  }
  return of(emergencydata);
}),


switchMap(emergencydata => {
  const religion_label = emergencydata?.medical_record?.religion_label;
  if (religion_label) {
    return from(this.translateSingleObject(religion_label)).pipe(
      map(translated => {
        emergencydata.medical_record.religion_label = translated;
        return emergencydata;
      })
    );
  }
  return of(emergencydata);
}),

        tap(emergencydata => {
          localStorage.setItem('currentMedicalUser', JSON.stringify(emergencydata));
          this.medicalUserSubject.next(emergencydata);
          this.medicalUser = this.medicalUserSubject.asObservable();
          this.pushMedicalInfo(this.medicalUserSubject.value);
        }),
  
        catchError(err => {
          const error = err.error.message || err.statusText;
          return throwError(() => new Error(error));
        })
      );
  }
  


// Function to translate critical_info section
translateCriticalInfo(criticalInfo: any): Promise<any[]> {
  if (criticalInfo && criticalInfo.length > 0) {
    const translatePromises = criticalInfo.map((item: any) => {
      const fieldsToTranslate = ['description', 'label'];
      return Promise.all(fieldsToTranslate.map(field => {
        if (typeof item[field] === 'string') {
          return this.translationMessage(item[field]).toPromise()
            .then((res: any) => {
              if (res?.translation?.translations?.[0]?.translation) {
                item[field] = res.translation.translations[0].translation;
              }
            })
            .catch(error => console.log(`Error translating ${field}:`, error));
        }
        return Promise.resolve();
      }));
    });

    return Promise.all(translatePromises);
  }
  return Promise.resolve([]); 
}

// Function to translate medical_diseases section
translateMedicalDiseases(medicalDiseases: any): Promise<any[]> {
  if (medicalDiseases && Object.keys(medicalDiseases).length > 0) {
    const diseaseKeys = Object.keys(medicalDiseases);
    const diseasePromises = diseaseKeys.map(diseaseKey => {
      const disease = medicalDiseases[diseaseKey];
      const fieldsToTranslate = ['name', 'label']; 

      // Translate 'name' and 'label' for the disease itself
      const translateDiseaseFields = fieldsToTranslate.map(field => {
        if (disease[field] && typeof disease[field] === 'string') {
          return this.translationMessage(disease[field]).toPromise()
            .then((res: any) => {
              if (res?.translation?.translations?.[0]?.translation) {
                disease[field] = res.translation.translations[0].translation;
              }
            })
            .catch(error => console.log(`Error translating disease ${field}:`, error));
        }
        return Promise.resolve(); 
      });

      // Process blocks within each disease
      if (disease.blocks && disease.blocks.length > 0) {
        const blockPromises = disease.blocks.map((block: any) => {
          const blockFieldsToTranslate = ['description', 'label']; 

          // Translate both 'description' and 'label' for each block
          return Promise.all(blockFieldsToTranslate.map(field => {
            if (block[field] && typeof block[field] === 'string') {
              return this.translationMessage(block[field]).toPromise()
                .then((res: any) => {
                  if (res?.translation?.translations?.[0]?.translation) {
                    block[field] = res.translation.translations[0].translation;
                  }
                })
                .catch(error => console.log(`Error translating block ${field}:`, error));
            }
            return Promise.resolve(); 
          }));
        });

        return Promise.all(blockPromises).then(() => Promise.all(translateDiseaseFields)); // Wait for both block and disease translations
      }

      return Promise.all(translateDiseaseFields); 
    });

    
    return Promise.all(diseasePromises);
  }

  
  return Promise.resolve([]);
}


// Function to translate immunizations section
translateImmunizations(immunizations: any): Promise<any[]> {
  if (immunizations && immunizations.blocks && immunizations.blocks.length > 0) {
    const blockPromises = immunizations.blocks.map((block: any) => {
      const fieldsToTranslate = ['description', 'label']; 

      return Promise.all(fieldsToTranslate.map(field => {
        if (block[field] && typeof block[field] === 'string') {
          return this.translationMessage(block[field]).toPromise()
            .then((res: any) => {
              if (res?.translation?.translations?.[0]?.translation) {
                block[field] = res.translation.translations[0].translation;
              }
            })
            .catch(error => console.log(`Error translating immunization block ${field}:`, error));
        }
        return Promise.resolve(); 
      }));
    });

    return Promise.all(blockPromises);
  }
  return Promise.resolve([]); 
}



translateOtherDisorders(otherDisorders: any[]): Promise<any[]> {
  const translatePromises = otherDisorders.map((item: any) => {
    const fieldsToTranslate = ['description', 'label'];

    return Promise.all(fieldsToTranslate.map(field => {
      if (typeof item[field] === 'string') {
        return this.translationMessage(item[field]).toPromise()
          .then((res: any) => {
            if (res?.translation?.translations?.[0]?.translation) {
              item[field] = res.translation.translations[0].translation;
            }
          })
          .catch(error => console.log(`Error translating ${field}:`, error));
      }
      return Promise.resolve(); 
    }));
  });

  // Ensure we always return a promise
  return Promise.all(translatePromises);
}



translateBloodDisorders(bloodDisorders: any[]): Promise<any[]> {
  const translatePromises = bloodDisorders.map((item: any) => {
    const fieldsToTranslate = ['diabete_description', 'diabete_label'];

    return Promise.all(fieldsToTranslate.map(field => {
      if (typeof item[field] === 'string') {
        return this.translationMessage(item[field]).toPromise()
          .then((res: any) => {
            if (res?.translation?.translations?.[0]?.translation) {
              item[field] = res.translation.translations[0].translation;
            }
          })
          .catch(error => console.log(`Error translating ${field}:`, error));
      }
      return Promise.resolve(); 
    }));
  });

  // Ensure we always return a promise
  return Promise.all(translatePromises);
}


translateMiscellaneous(miscellaneous: any[]): Promise<any[]> {
  const translatePromises = miscellaneous.map((item: any) => {
    const fieldsToTranslate = ['label', 'description'];

    return Promise.all(fieldsToTranslate.map(field => {
      if (typeof item[field] === 'string') {
        return this.translationMessage(item[field]).toPromise()
          .then((res: any) => {
            if (res?.translation?.translations?.[0]?.translation) {
              item[field] = res.translation.translations[0].translation;
            }
          })
          .catch(error => console.log(`Error translating ${field}:`, error));
      }
      return Promise.resolve(); 
    }));
  });

  // Ensure we always return a promise
  return Promise.all(translatePromises);
}

translateInsuranceInformation(insurance_info: any[]): Promise<any[]> {
  const translatePromises = insurance_info.map((item: any) => {
    const fieldsToTranslate = ['insurance_campany_name', 'additional_informations'];

    return Promise.all(fieldsToTranslate.map(field => {
      if (typeof item[field] === 'string') {
        return this.translationMessage(item[field]).toPromise()
          .then((res: any) => {
            if (res?.translation?.translations?.[0]?.translation) {
              item[field] = res.translation.translations[0].translation;
            }
          })
          .catch(error => console.log(`Error translating ${field}:`, error));
      }
      return Promise.resolve(); 
    }));
  });

  // Ensure we always return a promise
  return Promise.all(translatePromises);
}


translateDNR(resuscitate: any): Promise<any> {
  const rootFieldsToTranslate = ['description', 'label'];
  const documentFieldsToTranslate = ['document_name', 'label_doc'];

  const rootTranslations = Promise.all(
    rootFieldsToTranslate.map(field => {
      if (typeof resuscitate[field] === 'string') {
        return this.translationMessage(resuscitate[field]).toPromise()
          .then((res: any) => {
            if (res?.translation?.translations?.[0]?.translation) {
              resuscitate[field] = res.translation.translations[0].translation;
            }
          })
          .catch(error => console.log(`Error translating resuscitate.${field}:`, error));
      }
      return Promise.resolve();
    })
  );

  const documentTranslations = Promise.all(
    (resuscitate.documents || []).map((doc: any) => {
      return Promise.all(documentFieldsToTranslate.map(field => {
        if (typeof doc[field] === 'string') {
          return this.translationMessage(doc[field]).toPromise()
            .then((res: any) => {
              if (res?.translation?.translations?.[0]?.translation) {
                doc[field] = res.translation.translations[0].translation;
              }
            })
            .catch(error => console.log(`Error translating document.${field}:`, error));
        }
        return Promise.resolve();
      }));
    })
  );

  return Promise.all([rootTranslations, documentTranslations]).then(() => resuscitate);
}


translateOrganDonor(organ_donar: any): Promise<any> {
  const rootField = 'donar_information';
  const documentFieldsToTranslate = ['document_name', 'label_doc'];

  const rootTranslation = (typeof organ_donar[rootField] === 'string')
    ? this.translationMessage(organ_donar[rootField]).toPromise()
        .then((res: any) => {
          if (res?.translation?.translations?.[0]?.translation) {
            organ_donar[rootField] = res.translation.translations[0].translation;
          }
        })
        .catch(error => console.log(`Error translating ${rootField}:`, error))
    : Promise.resolve();

  const documentTranslations = Promise.all(
    (organ_donar.documents || []).map((doc: any) => {
      return Promise.all(documentFieldsToTranslate.map(field => {
        if (typeof doc[field] === 'string') {
          return this.translationMessage(doc[field]).toPromise()
            .then((res: any) => {
              if (res?.translation?.translations?.[0]?.translation) {
                doc[field] = res.translation.translations[0].translation;
              }
            })
            .catch(error => console.log(`Error translating document.${field}:`, error));
        }
        return Promise.resolve();
      }));
    })
  );

  return Promise.all([rootTranslation, documentTranslations]).then(() => organ_donar);
}


translateSingleObject(data: any): Promise<any> {
  if (typeof data === 'string') {
    return this.translationMessage(data).toPromise()
      .then((res: any) => {
        if (res?.translation?.translations?.[0]?.translation) {
          data = res.translation.translations[0].translation;
        }
        return data;
      })
      .catch(error => {
        // console.log('Error translating spoken_languages:', error);
        return data;
      });
  }

  return Promise.resolve(data);
}





// End of Medical Transaltion Section

 ApprouveEmereg(SerialNumber:string)
  {
    return this.http.get<any>(`${environment.apiUrl}/validate_generate_pin_code?sn=` + SerialNumber)
  }
  getTranslationId(lang: string): Observable<any> {

    return this.http.get<any>(`${environment.apiUrl}/get_id_language_from_abr?abr=${lang}`)
    .pipe(map(data => {
      return data;
    }));
    }

  // translationMessage(msg: string): Observable<any> {
  //     // let username = 'a88d44f4-92a8-44ff-a084-9f99c3811905';
  //     //  let password =
  //     //      'sZu0ZIX1QOKdO6QLxKsxJUJGJpAJF2vOS1AZu79VH8zOrFhf8n47pi7vDa5nTICg';

  //     let headers= new HttpHeaders();
  //     headers = headers.append('apiKey', environment.translateApiKey);

  //     // ({ 'Content-Type': 'application/json',
  //     const browserlang = this.translateService.getBrowserLang();

  //     var userLang = browserlang !== null ? browserlang : 'fr'
  //     // 'Authorization':"Basic " + btoa(username + ':' + password)}) ;
  //     var raw = {
  //       "text":msg,
  //       "translate_to":userLang
  //     };

  //     return this.http.request<any>('post', `${environment.apiUrl}/chatbot_translation`,
  //     {
  //       headers: headers,
  //       body:raw,
  //     });

  //     }



      translationMessage(msg: string): Observable<any> {
        const browserLang = this.translateService.getBrowserLang();
        const userLang = browserLang !== null ? browserLang : 'fr';
      
        // If the browser language is English, skip translation and return the message as-is
        if (userLang === 'en') {
          // console.log("No translation needed for English:", msg);
          const buttons = document.querySelectorAll(
        '#scrollbar-window chat-msg mat-card button.btn-link.btn-trans.bg-white.border-0'
      );
    buttons.forEach(button => {
    (button as HTMLElement).style.visibility = 'hidden';
      });

          return new Observable(observer => {
            observer.next({ translated_text: msg });
            observer.complete();
          });
        }
      
        let headers = new HttpHeaders().append('apiKey', environment.translateApiKey);
      
        const raw = {
          text: msg,
          translate_to: userLang.toUpperCase(),
        };
      
        return this.http.request<any>('post', `${environment.apiUrl}/chatbot_translation`, {
          headers: headers,
          body: raw,
        });
      }
      



// Translate Pet Info 
translatePetObject(obj: any, path: string = 'pet'): Observable<any> {
  if (!obj || typeof obj !== 'object') return of(obj);

  const excludedFields = ['preference_user', 'pet_picture_url','name'];
  const keys = Object.keys(obj);

  const translations$ = keys.map(key => {
    const value = obj[key];

    if (excludedFields.includes(key)) {
      return of({ key, value });
    }

    if (typeof value === 'string') {
      return this.translationMessage(value).pipe(
        map(res => ({
          key,
          value: res?.translation?.translations?.[0]?.translation ?? value
        })),
        catchError(() => of({ key, value })) // fallback
      );
    }

    if (Array.isArray(value)) {
      if (value.length === 0) return of({ key, value: [] });
      const arrayObservables = value.map((item, index) =>
        this.translatePetObject(item, `${path}.${key}[${index}]`)
      );
      return forkJoin(arrayObservables).pipe(
        map(translatedArray => ({ key, value: translatedArray }))
      );
    }

    if (typeof value === 'object') {
      return this.translatePetObject(value, `${path}.${key}`).pipe(
        map(translatedObj => ({ key, value: translatedObj }))
      );
    }

    return of({ key, value });
  });

  if (translations$.length === 0) return of({});

  return forkJoin(translations$).pipe(
    map(results => {
      const translatedObj: any = {};
      results.forEach(r => {
        translatedObj[r.key] = r.value;
      });
      return translatedObj;
    })
  );
}











    public getIPAddress()
    {
          return this.http.get("http://api.ipify.org/?format=json");
    }

    public blocip(ip : string){
      return this.http.get(`${environment.apiUrl}/block_ip?ip=${ip}`)
    }

    logout() {
      localStorage.removeItem('currentUser');
      this.currentUserSubject.next(null);
      this.router.navigate(['']);
    }

    getParamApp(){
      return this.http.get<any>(`${environment.apiUrl}/get_param_app` )
      .pipe(map(
        data => {
        this.paramAppSubject= new BehaviorSubject<ParamApplication>(data);
        this.paramApp = this.paramAppSubject.asObservable();
        return data;

      }),
     );
    }

    getViewUser(idUser: string ) {
      let queryParameters = new HttpParams();
      // queryParameters = queryParameters.append('id_user', idUser)
      return this.http.get(`${environment.apiUrl}/view_user?id_user=` + idUser+'&id_language=38');
    }

}
